// Module
var code = `<table class="compliance-list__table table table-hover table-style">
  <thead>
  <tr>
    <th>No</th>
    <th>Name</th>
    <th></th>
  </tr>
  </thead>

  <tbody>
  <tr ng-repeat="option in \$ctrl.options">
    <td>{{ \$index+1+'.' }}</td>
    <td>{{ option.name }}</td>
    <td>
      <a ng-href="{{ option.url }}" class="compliance-list__open-button btn btn-primary">
        Open
      </a>
    </td>
  </tr>
  </tbody>
</table>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/compliance/compliance-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;